module.exports = __webpack_public_path__ + "static/send-mail-icon.ba550ce0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/send-mail-icon.jpg
// module id = 30
// module chunks = 168707334958949